import HTTP from './http'
import { CognitoUserPool, CognitoUser } from 'amazon-cognito-identity-js'

const poolData = {
  UserPoolId: process.env.VUE_APP_AWS_COGNITO_POOL_ID,
  ClientId: process.env.VUE_APP_AWS_COGNITO_CLIENT_ID
}
const userPool = new CognitoUserPool(poolData)

const BASE_URL = '/login'

export default {
  async registerUser(userDetails) {
    const response = await HTTP.post(`${BASE_URL}/signup`, userDetails)
    return response.data.data
  },

  async login({ username, password }) {
    const response = await HTTP.post(`${BASE_URL}/`, { username, password })
    return response.data.data
  },

  async refreshToken({ username, password }) {
    return this.login({ username, password })
  },

  async logout() {
    // TODO:
  },

  async resetPasswordFlow(email) {
    const userData = {
      Username: email,
      Pool: userPool
    }

    const cognitoUser = new CognitoUser(userData)

    return new Promise((resolve, reject) => {
      cognitoUser.forgotPassword({
        onSuccess(result) {
          resolve(result)
        },
        onFailure(error) {
          reject(error)
        }
      })
    })
  },

  async resetPasswordWithCode({ email, code, password }) {
    const userData = {
      Username: email,
      Pool: userPool
    }

    const cognitoUser = new CognitoUser(userData)

    return new Promise((resolve, reject) => {
      cognitoUser.confirmPassword(code, password, {
        onSuccess(result) {
          resolve(result)
        },
        onFailure(error) {
          reject(error)
        }
      })
    })
  },

  async validateOtp({ email, otp }) {
    console.log(`Email value: ${email}`)
    console.log(`OTP value: ${otp}`)
    // TODO:
  }
}
